<div class="balloon-ecm">
  <span i18n="@@S_FUEL_INFO"
    class="balloon-ecm__header">Fuel Information</span>
  <div class="balloon-ecm__info">
    <span *ngIf="vehicleEcm.remainingFuelPercentage > 0"
      class="balloon-ecm__remaining-fuel">
      <mat-progress-bar class="balloon-ecm__progress-bar"
        [ngClass]="{ 'low-fuel': isLowOnFuel }"
        mode="determinate"
        [value]="remainingFuelPercentage"></mat-progress-bar>
      <span class="balloon-ecm__percentage">{{ remainingFuelPercentage }}%</span>
      <!-- <span i18n="@@S_MINS_AGO"
      class="balloon-ecm__last-update">{{ vehicleEcm.lastUpdateDiff }} mins ago</span> -->
    </span>
    <span class="balloon-ecm__average"
      *ngIf="vehicleEcm.fuelUsedLitres > 0">
      <span i18n="@@S_ECM_AVG">Avg.</span>
      <span class="avg-consumption">{{ vehicleEcm.fuelUsedLitres.toFixed(2) }}
        <ng-container [ngSwitch]="vehicleEcm.fuelEfficiencyUnit">
          <span *ngSwitchCase="EFuelEfficiencyUnits.MilesPerGallonUS"
            class="avg-consumption"
            i18n="@@S_FUEL_EFFICIENCY_UNITS_2">MPG</span>

          <span *ngSwitchCase="EFuelEfficiencyUnits.MilesPerGallonUK"
            class="avg-consumption"
            i18n="@@S_FUEL_EFFICIENCY_UNITS_4">MPG</span>

          <span *ngSwitchCase="EFuelEfficiencyUnits.KilometersPerLitre"
            class="avg-consumption"
            i18n="@@S_FUEL_EFFICIENCY_UNITS_5">km/L</span>

          <span *ngSwitchCase="EFuelEfficiencyUnits.KilometersPerGallonUS"
            class="avg-consumption"
            i18n="@@S_FUEL_EFFICIENCY_UNITS_6">km/gal</span>

          <span *ngSwitchDefault
            class="avg-consumption"
            i18n="@@S_FUEL_EFFICIENCY_UNITS_3">L/100km</span>
        </ng-container>
      </span>
    </span>
  </div>
</div>
